export default __webpack_public_path__ + "static/Alamofire-75b7ddfc07951ba8df40b69a4fc4312d.png";